import cn from "classnames";
import BookShow from "components/shared/book/show";
import Loader from "components/shared/loader";
import SharedReactTable from "components/shared/reactTable";
import { counterpartyStatusBadge } from "helpers/bid";
import { counterpartyStatuses } from "helpers/enums";
import { hiddenUserData } from "helpers/hiddenData";
import { paths } from "helpers/paths";
import { BooleanColumnFilter, EnumColumnFilter, rowIndexColumn } from "helpers/reactTable";
import { tableContainer, viewContainer } from "helpers/redux";
import policy from "policies";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { addCounterpartiesWithoutGroup, clear, setGroupForCounterparties } from "sources/books/counterpartyGroups";
import { config, initialState } from "../formConfig";

class ShowCounterpartyGroups extends BookShow {
    state = {
        isLoading: true,
        isValid: true,
        openedDropd: false,
        shouldUpdate: false,
        data: {},
        initial: {},
        tableColumns: this.tableColumns,
    };

    get tableColumns() {
        const columns = [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) =>
                    this.props.roles.isTruckingOrganizationDispatcher ? (
                        hiddenUserData(null, { type: "title" }, true)
                    ) : (
                        <Link to={`${paths.cargoOwnersShow(id)}?fromGroup=${this.props.match.params.id}`}>{value}</Link>
                    ),
            },
            {
                Header: "ИНН",
                accessor: "inn",
                filterable: true,
                Cell: ({ value }) =>
                    hiddenUserData(value, { type: "docNumber" }, this.props.roles.isTruckingOrganizationDispatcher),
            },
            {
                Header: "КПП",
                accessor: "kpp",
                filterable: true,
                Cell: ({ value }) =>
                    hiddenUserData(value, { type: "docNumber" }, this.props.roles.isTruckingOrganizationDispatcher),
            },
            {
                Header: "Открыт доступ",
                accessor: "hasAccess",
                sortable: false,
                filterable: true,
                filterType: "boolean",
                width: 150,
                Filter: BooleanColumnFilter,
                Cell: ({ value }) => (
                    <div className="text-center">
                        <span
                            className={cn("checkbox d-inline-block checkbox--disabled", { "checkbox--checked": value })}
                        />
                    </div>
                ),
                CSVExport: ({ value }) => (value ? "Да" : "Нет"),
            },
            {
                Header: "Статус",
                accessor: "status",
                filterable: true,
                filterType: "enum",
                Filter: (props) => <EnumColumnFilter {...props} filterEnum={counterpartyStatuses} />,
                Cell: ({ value }) => counterpartyStatusBadge(value, true),
                CSVExport: ({ value }) => value,
            },
            {
                Header: "Комментарий",
                accessor: "comment",
                filterable: true,
            },
            {
                Header: "",
                accessor: "action",
                sortable: false,
                Cell: ({
                    row: {
                        original: { id },
                    },
                }) => (
                    <div
                        className="btn btn-xs btn-outline-danger"
                        onClick={() =>
                            this.props.modal({
                                name: "confirm",
                                title: "Вы действительно хотите удалить контрагента из группы?",
                                buttons: { confirm: "Да", cancel: "Нет" },
                                action: () => {
                                    this.setState({ isLoading: true });
                                    setGroupForCounterparties({
                                        counterpartyGroupId: null,
                                        counterpartyIds: [id],
                                    }).then(() => {
                                        this.setState({ key: Date.now(), isLoading: false });
                                    });
                                },
                            })
                        }
                    >
                        Удалить
                    </div>
                ),
            },
        ];

        return columns;
    }

    getItem = ({ source, match }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        source.getItem(match.params).then((data) => this.setState({ data, initial: data, ...defParams }));
    };

    get dropdActions() {
        const { canEditBooks, roles } = this.props;
        return canEditBooks && policy("user", { user: { roles } }).isTruckingOrganizationAdmin()
            ? [
                  { text: "Переименовать группу", action: this.actionEdit },
                  { text: "Добавить в группу всех контрагентов без группы", action: this.actionAddWithoutGroup },
                  { text: "Удалить всех контрагентов из группы", action: this.actionClear },
                  { text: "Удалить группу", action: this.actionClose },
              ]
            : [];
    }

    actionAddWithoutGroup = () => {
        const { modal } = this.props;
        const { id } = this.props.match.params;
        return modal({
            name: "confirm",
            title: "Вы действительно хотите добавить в группу всех контрагентов без группы?",
            action: () =>
                addCounterpartiesWithoutGroup({ id }).then(() => {
                    this.getItem(this.props);
                    this.setState({ key: Date.now() });
                }),
            buttons: { confirm: "Добавить" },
        });
    };

    actionClear = () => {
        const { modal } = this.props;
        const { id } = this.props.match.params;
        return modal({
            name: "confirm",
            title: "Вы действительно хотите удалить всех контрагентов группы?",
            action: () =>
                clear({ id }).then(() => {
                    this.getItem(this.props);
                    this.setState({ key: Date.now() });
                }),
            buttons: { confirm: "Удалить" },
        });
    };

    actionEdit = () => {
        const { modal } = this.props;
        const { id } = this.props.match.params;
        return modal({
            name: "counterpartyGroupForm",
            title: "Изменение группы",
            id,
            callback: () => this.getItem(this.props),
        });
    };

    renderHead = () => {
        const { back } = this.props;
        return (
            <div className="book-show__head">
                <div className="book-show__close close close--sm" onClick={back} />
                <div className="book-show__title">
                    Группа контрагентов: <b>{this.state.data.name}</b>
                </div>
                {!!this.dropdActions.length && (
                    <div className="book-show__dropdown c-dropd">
                        <div className="c-dropd__btn" onClick={this.openDropd} />
                        {this.renderDropd()}
                    </div>
                )}
            </div>
        );
    };

    renderBodyWrap = () => {
        const { isLoading } = this.state;
        if (isLoading) {
            return <Loader prefix="absolute-center" />;
        }
        return this.renderBody();
    };

    renderBody = () => {
        const { id } = this.props.match.params;
        return (
            <ConfiguredTable
                key={this.state.key}
                counterpartyGroupId={Number(id)}
                wrapCname="h-100"
                columns={this.state.tableColumns}
            />
        );
    };
}

const Table = (props) => {
    useEffect(() => {
        return () => props.clearParams();
    }, []);

    const getList = (params) => {
        params.preparedFilter.and = { ...params.preparedFilter.and, counterpartyGroupId: props.counterpartyGroupId };
        return props.getList(params);
    };
    return <SharedReactTable {...props} getList={getList} />;
};

const ConfiguredTable = tableContainer(Table, "cargoowners");

const ConfiguredShow = (props) => <ShowCounterpartyGroups {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "counterparty-groups");
